import ARTICLETITLEBORDER from './articleTitleBorder.svg';
import LOGOCDMI from './logo-cdmi.png';
import LOGOMARISTA from './logo-marista.svg';
import LOGOFTD from './logoFTD.svg';

interface dataProps {
  [key: string]: string;
}

/* eslint-disable quote-props */
const data: dataProps = {
  'ARTICLETITLEBORDER': ARTICLETITLEBORDER,
  'LOGO-CDMI': LOGOCDMI,
  'LOGO-MARISTA': LOGOMARISTA,
  'LOGOFTD': LOGOFTD,
};
export default data;
